import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// ⚠️ LES POLICES SONT SERVIES PAR L'APPLICATION, PAS PAR UN TIERS. Le
// `<link>` vers fonts.googleapis.com d'`index.html` a été retiré au lot RU1, et
// la raison n'est PAS le RGPD : c'est la MAÎTRISE. L'application doit s'afficher
// à l'identique partout. Des réseaux d'entreprise filtrent
// `fonts.googleapis.com` ; le premier rendu y tombait alors en police système,
// sans que rien ne le signale.
//
// ⚠️ Deux polices, une par écriture — cf. `theme/jetons.js` : Inter n'a AUCUN
// glyphe hébreu, et l'application est trilingue fr/en/he.
import '@fontsource-variable/inter';
import '@fontsource-variable/noto-sans-hebrew';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import './index.css';

// 🔴 LE THÈME N'EST PLUS ICI. Il vivait dans ce fichier — 170 lignes de
// `createTheme` mêlant les valeurs choisies et les valeurs calculées. Il est
// désormais dans `theme/` : `jetons.js` pour ce qu'on décide, `creerTheme.js`
// pour la façon de l'assembler, et `ThemeModeProvider` pour le mode d'affichage
// (clair / sombre / auto), qui ne peut pas être une constante.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    {/* ── L'ORDRE DES FOURNISSEURS EST UNE DÉCISION, PAS UN EMPILEMENT ──────
        🔴 `LanguageProvider` EST REMONTÉ AU-DESSUS DE `ThemeModeProvider`
        (RU8-a). La DIRECTION d'écriture est une propriété de la LANGUE, et le
        thème la porte (`theme.direction`, et le cache de style retourné) :
        **le thème dépend donc de la langue, jamais l'inverse.** Avant ce lot,
        `ThemeModeProvider` était ici et `LanguageProvider` à l'intérieur
        d'`App` — le thème ne pouvait pas savoir dans quelle langue il peignait.

        ⚠️ MESURÉ AVANT DE DÉPLACER : les deux seuls consommateurs du thème,
        `Profile.js` et `Dashboard.js`, vivent sous `AppContent`. **Personne ne
        lisait le thème entre les deux fournisseurs.**

        ⚠️ ET `ErrorBoundary` EST REMONTÉ AVEC EUX. Il vivait dans `App` et
        enveloppait `LanguageProvider` ; le laisser en bas aurait laissé les
        deux fournisseurs déplacés **hors de tout filet**. Il ne consomme ni
        thème ni traduction — c'est ce qui l'autorise à être tout en haut. */}
    <ErrorBoundary>
      <LanguageProvider>
        <ThemeModeProvider>
          <App />
        </ThemeModeProvider>
      </LanguageProvider>
    </ErrorBoundary>
  </BrowserRouter>
);
